'use strict'

export function formatCommentTime (time) {//格式化 晒单 评论 日期展示格式
  let actionTime = ""
  if(time) {
    let nowTime = new Date().getTime()
    let timeObj = formatTime(time)
    let nowTimeObj = formatTime(nowTime)
    // console.log(timeObj, nowTimeObj)

    if(!timeObj || !nowTimeObj) {
      actionTime = ""
    } else {
      if(nowTimeObj.year !== timeObj.year) {//不同年
        actionTime = `${timeObj.year}年${timeObj.month}月${timeObj.day}日`
      } else {
        if(nowTimeObj.month !== timeObj.month) {//不同月
          actionTime = `${timeObj.month}月${timeObj.day}日`
        } else {
          if(nowTimeObj.day !== timeObj.day) {
            if(nowTimeObj.day - timeObj.day === 1) {//相差一天
              actionTime = `昨天`
            } else {//大于一天
              actionTime = `${timeObj.month}月${timeObj.day}日`
            }
          } else {//同年 同月 同日
            if(nowTimeObj.hh === timeObj.hh) {//同一个小时内
              if(nowTimeObj.mm - timeObj.mm > 1) {
                actionTime = `${nowTimeObj.mm-timeObj.mm}分钟前`
              } else {
                actionTime = `刚刚`
              }
            } else {
              actionTime = `${nowTimeObj.hh-timeObj.hh}小时前`
            }
          }
        }
      }
    }

  }

  // this.actionTime = actionTime
  return actionTime
}

export function formatTime (time) {//返回 年月日 时分秒
  if(!time) {
    return ''
  }

  let date = new Date(parseInt(time, 10))
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()

  return {
    year,
    month,
    day,
    hour,
    minute,
    second
  }
}

export function getCountDown (time, diffTime=0) {//返回 倒计时天时分秒  或者总小时分秒
  if(!time) {
    return null
  }
  const now = new Date().getTime()
  let endDate = new Date(time),
      // _now = new Date()
    _now = new Date(now -diffTime)
    
  let leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
    leftsecond = parseInt(leftTime),
    day = Math.floor(leftsecond / (60 * 60 * 24)),
    hour = Math.floor((leftsecond - day * 24 * 60 * 60) / 3600),
    minute = Math.floor((leftsecond - day * 24 * 60 * 60 - hour * 3600) / 60),
    second = Math.floor(leftsecond - day * 24 * 60 * 60 - hour * 3600 - minute * 60),
    totalHour = hour + day*24

  return {
    day,
    hour,
    minute,
    second,
    totalHour
  }
}

export function transformTime (time) {//2018-01-01 12:00:00  IOS中不支持 - 连接日期 返回valid Date
  if (!time) {
    return 0
  }
  let date = new Date(time.replace(/-/g,'/'))
  return date.getTime()
}

export function addZero (time) {
  if(time < 10) {
    return `0${time}`
  } else {
    return time
  }
}

export function transformFutureCalenderNew ({dateArr}) {//格式化
  const DAY31 = [1, 31]
  const DAY30 = [1, 30]
  const DAY29 = [1, 29]
  const DAY28 = [1, 28]
  let oneyearFlag = true
  if(dateArr[0].year !== dateArr[1].year) {
    oneyearFlag = false
  }

  let yearArr = []
  dateArr.forEach((d, index) => {
    let y = d.year
    let yObj = {
      c: d.year,
      n: d.year,
      cns: []
    }
    
    const monthMap = {
      1: DAY31,
      2: y%4?DAY28:DAY29,
      3: DAY31,
      4: DAY30,
      5: DAY31,
      6: DAY30,
      7: DAY31,
      8: DAY31,
      9: DAY30,
      10: DAY31,
      11: DAY30,
      12: DAY31
    }

    let monthArr = []
    let m = d.month
    let monthObj = {
      c: m,
      n: m<10?`0${m}`:`${m}`,
      pc: y
    }

    let dayGap = monthMap[m]
    let dayArr = []
    for(let d=dayGap[0];d<=dayGap[1];d++) {
      let dayObj = {
        c: d,
        n: d<10?`0${d}`:`${d}`,
        pc: m
      }
      dayArr.push(dayObj)
    }

    monthObj.cns = dayArr
    
    if(index == 0) {
      yObj.cns.push(monthObj)
      yearArr.push(yObj)
    } else {
      if(oneyearFlag) {
        yearArr[0].cns.push(monthObj)
      } else {
        yObj.cns.push(monthObj)
        yearArr.push(yObj)
      }
    }

  })

  console.log(yearArr, "yearArr")
  return yearArr
}

export function transformFutureCalender ({startDate=null, yearGap=1}) {//格式化
  const DAY31 = [1, 31]
  const DAY30 = [1, 30]
  const DAY29 = [1, 29]
  const DAY28 = [1, 28]

  startDate = startDate || new Date()
  const year = startDate.getFullYear()
  const month = startDate.getMonth()+1
  const day = startDate.getDate()

  let yearDatas = []
  for(let t=0; t<=yearGap; t++) {
    yearDatas.push(year+t)
  }

  let yearArr = []
  yearDatas.forEach((y, index) => {
    let yObj = {
      c: y,
      n: y
    }
    
    const monthMap = {
      1: DAY31,
      2: y%4?DAY28:DAY29,
      3: DAY31,
      4: DAY30,
      5: DAY31,
      6: DAY30,
      7: DAY31,
      8: DAY31,
      9: DAY30,
      10: DAY31,
      11: DAY30,
      12: DAY31
    }
    
    let monthArr = []
    for(let m=1;m<=12;m++) {
      if(index === 0 && month>m) {//当年的前几个月
        continue;
      }
      let monthObj = {
        c: m,
        n: m<10?`0${m}`:`${m}`,
        pc: y
      }

      let dayGap = monthMap[m]
      if(index === 0 && month === m) {//当年 当月
        dayGap = [day, dayGap[1]]
      }

      let dayArr = []
      for(let d=dayGap[0];d<=dayGap[1];d++) {
        let dayObj = {
          c: d,
          n: d<10?`0${d}`:`${d}`,
          pc: m
        }
        dayArr.push(dayObj)
      }

      monthObj.cns = dayArr
      monthArr.push(monthObj)
    }

    yObj.cns = monthArr
    yearArr.push(yObj)
  })

  console.log(yearArr, "yearArr")
  return yearArr
}



// WEBPACK FOOTER //
// ./static/time/index.js